export default "__VITE_ASSET__CFw3fXq0__"